// Google Docs pdf embed workaround based on https://stackoverflow.com/a/61451002
import React, { useEffect, useRef } from 'react'

const EmbededPdfScreen = props => {
  const { url } = props

  const timeoutRef = useRef()

  const iframeRef = useRef()

  const source = `https://docs.google.com/gview?embedded=true&url=${url}`

  const setIframeSource = () => {
    if (iframeRef.current) {
      iframeRef.current.src = source
    }
  }

  const onIframeLoad = () => {
    const contentLoaded = iframeRef.current?.contentWindow?.length

    if (contentLoaded) {
      clearInterval(timeoutRef.current)

      return
    }

    setIframeSource()
  }

  useEffect(() => {
    // 3 seconds is an arbitrary value to expect the iframe content to load
    timeoutRef.current = setInterval(setIframeSource, 1000 * 3)
  }, [])

  return (
    <div style={{ overflow: 'hidden', height: '100vh' }}>
      <iframe
        title="preview document"
        src={source}
        width="100%"
        height="100%"
        ref={iframeRef}
        onError={setIframeSource}
        onLoad={onIframeLoad}
      />
    </div>
  )
}

export default EmbededPdfScreen
